<mb-form-field appearance="light">
  <label mb-form-field-label for="price-by">Ver</label>
  <select mb-form-field-input id="price-by" [(ngModel)]="priceBy" (change)="changePriceBy()" [disabled]="disabled">
    <option value="NIGHT" i18n="@@price__night">Precio por noche por habitación</option>
    <option value="TOTAL" i18n="@@price__total">Precio total</option>
  </select>
</mb-form-field>